/* Per-card image slider for sections/product-grid-slider.liquid.
   Dependency-free custom element: no Liquid, no build step. */
  (function () {
'use strict';

/* A custom element (rather than a querySelector-on-load script) so each card
   wires itself up whenever the theme editor replaces this section's markup,
   and all state stays scoped to "this" without id bookkeeping. Same pattern
   as coverflow-slider.liquid. */
class ProductGridSliderCard extends HTMLElement {
  connectedCallback() {
    if (this._pgsInitialized) return;
    this._pgsInitialized = true;

    var card = this;
    var track = this.querySelector('[data-pgs-track]');
    var count = parseInt(this.getAttribute('data-slide-count'), 10) || 0;
    if (!track || count < 2) return;

    var dots = Array.prototype.slice.call(this.querySelectorAll('[data-pgs-dot]'));
    var media = track.parentNode;
    var index = 0;
    var dragDx = 0;

    function render(animated) {
      var width = media.clientWidth || 0;
      track.style.transition = animated ? '' : 'none';
      track.style.transform = 'translate3d(' + (dragDx - index * width) + 'px, 0, 0)';
    }

    function goTo(next, animated) {
      index = Math.max(0, Math.min(count - 1, next));
      /* Retires the hover overlay for good once the visitor has driven the
         slider -- otherwise it would cover every slide they pick. */
      card.classList.add('is-slid');
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === index;
        dots[i].classList.toggle('is-active', isActive);
        if (isActive) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
      render(animated);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i, true); });
    });

    /* Drag/swipe: touch devices get no hover and the 6px dots are a poor
       target, so the images themselves have to be draggable. Listeners sit
       on the card rather than the track because the stretched link's ::after
       covers the media area and would otherwise swallow every pointerdown. */
    var isDragging = false;
    var dragMoved = false;
    var startX = 0;
    var startY = 0;

    card.addEventListener('pointerdown', function (evt) {
      if (evt.button !== 0 && evt.pointerType === 'mouse') return;
      if (evt.target.closest('[data-pgs-dot]')) return;
      isDragging = true;
      dragMoved = false;
      startX = evt.clientX;
      startY = evt.clientY;
    });

    card.addEventListener('pointermove', function (evt) {
      if (!isDragging) return;
      var dx = evt.clientX - startX;

      /* Wait until the gesture is clearly horizontal before claiming it, so a
         vertical flick still scrolls the page instead of nudging the slider. */
      if (!dragMoved) {
        if (Math.abs(dx) < 8) return;
        if (Math.abs(dx) <= Math.abs(evt.clientY - startY)) return;
        dragMoved = true;
        if (card.setPointerCapture) card.setPointerCapture(evt.pointerId);
      }

      /* Resist dragging past either end so the track can't be pulled into blank space. */
      if ((index === 0 && dx > 0) || (index === count - 1 && dx < 0)) dx *= 0.25;
      dragDx = dx;
      render(false);
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      if (!dragMoved) return;

      var threshold = (media.clientWidth || 0) * 0.2;
      var next = index;
      if (dragDx <= -threshold) next = index + 1;
      if (dragDx >= threshold) next = index - 1;
      dragDx = 0;
      goTo(next, true);
    }

    card.addEventListener('pointerup', endDrag);
    card.addEventListener('pointercancel', endDrag);

    /* Suppress the click a drag would otherwise fire on the stretched link. */
    card.addEventListener('click', function (evt) {
      if (dragMoved) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }, true);

    this._pgsRender = function () { render(false); };
    window.addEventListener('resize', this._pgsRender);
  }

  disconnectedCallback() {
    this._pgsInitialized = false;
    if (this._pgsRender) window.removeEventListener('resize', this._pgsRender);
  }
}

if (!customElements.get('product-grid-slider-card')) {
  customElements.define('product-grid-slider-card', ProductGridSliderCard);
}
  })();